import { Component, Input, OnInit } from '@angular/core';
import { EnvironmentService } from 'projects/shared/services/environment.service';
import { MortgageApplicationService } from '../../services/mortgage-application.service';
import { Constants } from '../../services/constants';

@Component({
    selector: 'application-submitted',
    templateUrl: 'application-submitted.component.html',
    standalone: false
})

export class ApplicationSubmittedComponent implements OnInit {

  @Input()
  heading?: string;

  @Input()
  message1?: string;

  @Input()
  message2?: string;

  @Input()
  showImage: boolean = true;

  constructor(private _environmentService: EnvironmentService,
    private _mortgageApplicationService: MortgageApplicationService) { }

  ngOnInit() { }

  onGotoBorrowerPortalClicked = () => {
    this._mortgageApplicationService.getBorrowerPortalUrl().subscribe(url => {
      setTimeout(() => {
        //redirect
        const authorizationDataKey: string = Constants.authorization.authorizationDataKey;
        const authDataObj = JSON.parse(localStorage.getItem(authorizationDataKey)!);
        const token = authDataObj.token;
        const redirectUrl = "https://" + url + "/loans-redirect/"
          + this._mortgageApplicationService.mortgageApplication.applicationId + "?authToken=" + token;
        window.location.href = redirectUrl;
      }, 2000);
    }, error => {

    })
  }
}
